import React, { useEffect, useState } from 'react';
import './App.css';
import { Route, Routes } from 'react-router-dom';
import PageLogin from './pages/login';
import PageReport from './pages/report';

import PageQRCode from './pages/qrcode';
import bg from './assets/bg-rkdtip.png';
import PageCheckin from './pages/login/checkin';
import PageReportCheckin from './pages/report_checkin';
import PageReportReset from './pages/report_reset';

function App() {
  const [setting, setSetting] = useState(null);

  return (
    <>
      <div
        className="overflow-y-auto min-h-screen bg-cover bg-center"
        style={{ backgroundImage: `url(${bg})` }}>
        <Routes>
          <Route path="/" element={<PageLogin setting={setting} />} />
          <Route path="/checkin" element={<PageCheckin setting={setting} />} />
          <Route path="/report" element={<PageReport setting={setting} />} />
          <Route
            path="/report-checkin"
            element={<PageReportCheckin setting={setting} />}
          />
           <Route
            path="/reset-reset-asd"
            element={<PageReportReset setting={setting} />}
          />
          <Route path="/qrcode" element={<PageQRCode />} />
        </Routes>
      </div>
    </>
  );
}

export default App;
